module.exports = __webpack_public_path__ + "img/icon_4.a1603804.png";